export { default as Img200 } from './processed/200/Patient-Zero.jpg';
export { default as Img400 } from './processed/400/Patient-Zero.jpg';
export { default as Imgthumb } from './processed/thumb/Patient-Zero.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Patient-Zero.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Patient-Zero.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      193,
      64,
      40
    ],
    "_population": 151,
    "_hsl": [
      0.026143790849673203,
      0.6566523605150214,
      0.4568627450980392
    ]
  },
  "LightVibrant": {
    "_rgb": [
      196,
      212,
      228
    ],
    "_population": 427,
    "_hsl": [
      0.5833333333333334,
      0.37209302325581395,
      0.8313725490196079
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      124,
      47,
      36
    ],
    "_population": 3222,
    "_hsl": [
      0.02083333333333334,
      0.55,
      0.3137254901960784
    ]
  },
  "Muted": {
    "_rgb": [
      148,
      111,
      93
    ],
    "_population": 193,
    "_hsl": [
      0.05454545454545454,
      0.22821576763485485,
      0.4725490196078431
    ]
  },
  "LightMuted": {
    "_rgb": [
      188,
      212,
      219
    ],
    "_population": 2711,
    "_hsl": [
      0.5376344086021504,
      0.3009708737864076,
      0.7980392156862746
    ]
  },
  "DarkMuted": {
    "_rgb": [
      82,
      68,
      76
    ],
    "_population": 9,
    "_hsl": [
      0.9047619047619048,
      0.09333333333333338,
      0.29411764705882354
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Patient-Zero.js